if (!customElements.get('product-label')) {
  customElements.define(
    'product-label',
    class ProductLabel extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('.wt-product__label__trigger');
        this.popup = this.querySelector('.wt-product__label__popup');
        this.closeBtn = this.querySelector('.wt-product__label__popup__close');

        if (!this.trigger || !this.popup) return;

        this.handleOutsideClick = (event) => {
          if (!this.contains(event.target)) {
            this.close();
          }
        };

        this.handleEscKey = (event) => {
          if (event.key === 'Escape') {
            this.close();
          }
        };

        this.trigger.addEventListener('click', (event) => {
          event.stopPropagation();
          this.toggle();
        });

        this.closeBtn?.addEventListener('click', (event) => {
          event.stopPropagation();
          this.close();
        });
      }

      toggle() {
        const isOpen = !this.classList.contains('wt-product__label--open');

        if (isOpen) {
          this.open();
        } else {
          this.close();
        }
      }

      open() {
        this.classList.add('wt-product__label--open');
        this.trigger.setAttribute('aria-expanded', 'true');
        this.popup.setAttribute('aria-hidden', 'false');
        document.addEventListener('click', this.handleOutsideClick);
        document.addEventListener('keydown', this.handleEscKey);
      }

      close() {
        this.classList.remove('wt-product__label--open');
        this.trigger.setAttribute('aria-expanded', 'false');
        this.popup.setAttribute('aria-hidden', 'true');
        document.removeEventListener('click', this.handleOutsideClick);
        document.removeEventListener('keydown', this.handleEscKey);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.handleOutsideClick);
        document.removeEventListener('keydown', this.handleEscKey);
      }
    }
  );
}
